import state from "./state";

export default {
  currentTime: (state) => state.time,
  portletId: (state) => state.portletId,
  // rakenteet, lvi jne
  activeComponent: (state) => {
    return state.componentId;
  },
  getZoomState: (state) => {
    return state.zoomState;
  },
  sideNavigationWideStatus: (state) => {
    return state.wideAsidePanel;
  },
  streetViewStatus: (state) => {
    return state.streetview;
  },
  activeMapButton: () => {
    return state.activeMapButton;
  },
  componentSelectionDropdownOpen: () => {
    return state.componentSelectionDropdownOpen;
  },
  escClicked: () => {
    return state.escClicked;
  },
};
